module.exports = __webpack_public_path__ + "img/amazon-icon (2).55eb619a.svg";